
import { SlvUgcReplyOVO, UgcVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BottomSheets from '@/components/BottomSheets.vue';
import UgcDetailComponent from "@/components/UgcDetailComponent.vue"
import UgcReportForm from "@/components/UgcReportForm.vue";
import CommonUtils from "@/common-utils";

@Component({
  components: { BottomSheets, UgcReportForm, UgcDetailComponent }
})
export default class UgcDetail extends Vue {
  @Prop() productCd!: string;
  @Prop() ugcCd!: string;

  ugc = {} as UgcVO;

  search() {
    axios.get(`/ugc/${this.ugcCd}`).then(r => {
      this.ugc = r.data;
    })
  }

  created() {
    this.search()
  }

}
